<template>
  <dashboard-page :image-header-props="imageHeaderProps">
    <template v-slot:dashboard>
      <div class="margin-ml">
        <property class="margin-bottom-m" :name="'סוג מינוי'" :value="subscriptionTypeText"/>
        <property class="margin-bottom-m canceled" :name="'מצב המינוי'" :value="'מבוטל'" value-color="red"/>
        <property class="margin-bottom-m" :name="'תאריך סיום המינוי'" :value="statusChangedDateFormatted"/>
        <div v-if="benefitId && !redeemed">
          <benefit-notification-box-v2 :flavor="flavors.accountSettings" />
        </div>
      </div>

      <separator />
      <div class="margin-ml">
        <riseup-button :action="openUpdateCreditCardPopup" :size="'slim'" :title="'לעדכן אמצעי תשלום'"/>
      </div>
    </template>
  </dashboard-page>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { mapGetters, mapState } from 'vuex';
import BenefitNotificationBoxV2
  from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitNotificationBox2.vue';
import BenefitMixin from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitMixin.vue';
import dates from '@/utils/dates';
import AccountSettingsMixin
  from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/AccountSettingsMixin.vue';
import UpdateCreditCardHandler
  from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/UpdateCreditCardHandler.vue';
import Property from './Property.vue';

export default {
  name: 'CanceledSettings',
  components: {
    BenefitNotificationBoxV2,
    Property,
    DashboardPage: BaseUI.Pages.DashboardPage,
    RiseupButton: BaseUI.RiseupButton,
    Separator: BaseUI.Separator,
  },
  mixins: [BenefitMixin, AccountSettingsMixin, UpdateCreditCardHandler],
  computed: {
    ...mapState('benefits', ['benefitId', 'redeemed']),
    // TODO rethink promos during canceled & dormant-after-canceled during update flows
    // currently credit card v1 flow does not support promos, so not showing the promos currently in the ui
    ...mapGetters('subscription', ['subscriptionTypeText']),
    ...mapState('subscriptionState', ['since']),
    statusChangedDateFormatted() {
      return dates.shortDateFormat(this.since);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./settings";
@include properties;

</style>
